import { render, staticRenderFns } from "./CompareRestaurantCompareCell.vue?vue&type=template&id=08988e92&"
import script from "./CompareRestaurantCompareCell.vue?vue&type=script&lang=js&"
export * from "./CompareRestaurantCompareCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports